import { render } from "./simple_editor.vue?vue&type=template&id=a87e034e"
import script from "./simple_editor.vue?vue&type=script&lang=js"
export * from "./simple_editor.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__